<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="fas fa-list-ul" class="q-mb-sm" /> {{ $t('configuration') }}
		</div>

		<q-tabs class="shadow-2" color="secondary" scroll>
			<q-tab default slot="title" name="login" label="login" />
			<q-tab slot="title" name="register" label="register" />
			<q-tab slot="title" name="self_register" label="self_register" />
			<q-tab slot="title" name="user_profile" label="user_profile" />
			<q-tab slot="title" name="layout" label="layout" />
			<q-tab slot="title" name="social_auth" label="social_auth" />
			<q-tab slot="title" name="pqrc_register" label="pqrc_register" />
			<q-tab slot="title" name="wqrc_register" label="wqrc_register" />
			<q-tab slot="title" :name="`c${client.id}`" :label="getClientName(client.id)"
				v-for="(client, index) in clients" :key="`t${index}`" v-if="disablegetClientName(client.id)" />

			<q-tab-pane name="login">
				<div class="row reverse gutter-md">
					<div class="col-12" v-for="(item, index) in login" :key="index">
						<q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-select v-model="item.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

						<div class="row" v-if="item.type === 'color'">
							<span class="q-caption text-faded">{{ $t('colors') }}</span>
							<div class="col-12" v-for="(color, index) in item.value" :key="`c${index}`">
								<q-field :helper="color.helper">
									<q-color v-model="color.value" :float-label="color.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'background_color'">
							<div class="col-12">
								<q-field :helper="item.helper">
									<q-color v-model="item.value" :float-label="item.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'font_color'">
							<div class="col-12">
								<q-field :helper="item.helper">
									<q-color v-model="item.value" :float-label="item.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'oauth2'">
							<span class="q-caption text-faded">{{ $t('oauth2') }}</span>
							<div class="col-12" v-for="(oauth2, index) in item.value" :key="`c${index}`">
								<q-field v-if="oauth2.label !== 'is_active'" :helper="oauth2.helper">
									<q-input v-model="oauth2.value" :float-label="oauth2.label" />
								</q-field>
								<q-select v-model="oauth2.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="oauth2.label" v-else />
							</div>
						</div>

						<div class="row" v-if="item.type === 'upload'">
							<span class="q-caption text-faded">{{ item.label }}</span>
							<div class="col-12">
								<uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false"
									:cropper="false" :item="item" :custom_directory="true" :filename="item.label"
									:slug="'login'" :aspect_ratio="getAspectNumber(item)"
									:aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

								<span class="q-caption text-faded">{{ item.helper }}</span>

								<p v-if="item.value" class="q-mt-md file-url">
									<q-icon name="fas fa-check" color="positive" />
									<a :href="item.value" target="_blank">
										{{ $truncateLink(item.value) }}</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>

			<q-tab-pane name="register">
				<div class="row reverse gutter-sm">
					<div class="col-12" v-for="(item, index) in register" :key="index">


						<q-field :helper="item.helper"
							v-if="(item.type === 'boolean' || item.type === 'text') && !hasCustomInputRender('register', item.label)">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-select v-model="item.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

						<q-filed v-if="item.label === 'password_strong_level'">
							<q-select v-model="item.value" :float-label="item.label" :options="[
				{ value: 'easy', label: 'Fraca' },
				{ value: 'medium', label: 'Média' },
				{ value: 'hard', label: 'Forte' },
			]" />
							<span class="q-caption text-faded">{{ item.helper }}</span>
						</q-filed>

						<div class="row" v-if="item.type === 'field'">

							<span class="q-caption text-faded">{{ $t('fields') }}</span>
							<div class="col-12" v-for="(field, index) in item.value" :key="`c${index}`">
								<div class="row" v-if="field.label === 'password_strong_level'">
									<q-select v-model="field.value" :options="[
				{ value: 'easy', label: 'Fácil' },
				{ value: 'medium', label: 'Normal' },
				{ value: 'hard', label: 'Difícil' },
			]" />
								</div>

								<q-field v-if="!hasCustomInputRender('register', field.label)" :helper="field.helper">
									<q-select v-model="field.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="field.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'upload'">
							<span class="q-caption text-faded">{{ item.label }}</span>
							<div class="col-12">
								<uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false"
									:cropper="false" :item="item" :custom_directory="true" :filename="item.label"
									:slug="'login'" :aspect_ratio="getAspectNumber(item)"
									:aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

								<span class="q-caption text-faded">{{ item.helper }}</span>

								<p v-if="item.value" class="q-mt-md file-url">
									<q-icon name="fas fa-check" color="positive" />
									<a :href="item.value" target="_blank">
										{{ $truncateLink(item.value) }}</a>
								</p>
							</div>
						</div>

					</div>
				</div>
			</q-tab-pane>

			<q-tab-pane name="self_register">
				<div class="row reverse gutter-sm">
					<div class="col-12" v-for="(item, index) in self_register" :key="index">
						<q-field :helper="item.helper"
							v-if="item.type === 'boolean' || item.type === 'text' && !hasCustomInputRender('self_register', item.label)">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-select v-model="item.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

						<div class="row" v-if="item.type === 'field'">
							<span class="q-caption text-faded">{{ $t('fields') }}</span>
							<div class="col-12" v-for="(field, index) in item.value" :key="`c${index}`">
								<q-field :helper="field.helper">
									<q-select v-model="field.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="field.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'upload'">
							<span class="q-caption text-faded">{{ item.label }}</span>
							<div class="col-12">
								<uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false"
									:cropper="false" :item="item" :custom_directory="true" :filename="item.label"
									:slug="'login'" :aspect_ratio="getAspectNumber(item)"
									:aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

								<span class="q-caption text-faded">{{ item.helper }}</span>

								<p v-if="item.value" class="q-mt-md file-url">
									<q-icon name="fas fa-check" color="positive" />
									<a :href="item.value" target="_blank">
										{{ $truncateLink(item.value) }}</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>

			<q-tab-pane name="user_profile">
				<div class="row reverse gutter-sm">
					<div class="col-12" v-for="(item, index) in user_profile" :key="index">
						<q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-select v-model="item.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

						<div class="row" v-if="item.type === 'field'">
							<span class="q-caption text-faded">{{ $t('fields') }}</span>
							<div class="col-12" v-for="(field, index) in item.value" :key="`c${index}`">
								<q-field :helper="field.helper">
									<q-select v-model="field.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="field.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'upload'">
							<span class="q-caption text-faded">{{ item.label }}</span>
							<div class="col-12">
								<uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false"
									:cropper="false" :item="item" :custom_directory="true" :filename="item.label"
									:slug="'login'" :aspect_ratio="getAspectNumber(item)"
									:aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

								<span class="q-caption text-faded">{{ item.helper }}</span>

								<p v-if="item.value" class="q-mt-md file-url">
									<q-icon name="fas fa-check" color="positive" />
									<a :href="item.value" target="_blank">
										{{ $truncateLink(item.value) }}</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>

			<q-tab-pane name="layout">
				<div class="row reverse gutter-sm">
					<div class="col-12" v-for="(item, index) in layout" :key="index">
						<q-field :helper="item.helper" v-if="item.type === 'boolean' ||
				item.type === 'text' ||
				item.type === 'color'
				">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-color v-model="item.value" :float-label="item.label" v-if="item.type === 'color'" />

							<q-select v-model="item.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

						<div class="row" v-if="item.type === 'upload'">
							<span class="q-caption text-faded">{{ item.label }}</span>
							<div class="col-12">
								<uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false"
									:cropper="false" :item="item" :custom_directory="true" :filename="item.label"
									:slug="'login'" :aspect_ratio="getAspectNumber(item)"
									:aspect_ratio_string="getAspectString(item)" :no_expiration="true" />

								<span class="q-caption text-faded">{{ item.helper }}</span>

								<p v-if="item.value" class="q-mt-md file-url">
									<q-icon name="fas fa-check" color="positive" />
									<a :href="item.value" target="_blank">
										{{ $truncateLink(item.value) }}</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>

			<q-tab-pane name="social_auth">
				<div class="row reverse gutter-sm">
					<div class="col-12" v-for="(item, index) in social_auth" :key="index">
						<q-field :helper="item.helper" v-if="(item.type === 'boolean' || item.type === 'text')">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-select v-model="item.value" :options="[
				{ value: true, label: 'true' },
				{ value: false, label: 'false' },
			]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

					</div>
				</div>
			</q-tab-pane>

			<q-tab-pane name="pqrc_register">
				<div class="row reverse gutter-sm">
					<div class="col-12" v-for="(item, index) in pqrc_register" :key="index">
						<q-field :helper="item.helper" v-if="(item.type === 'boolean' || item.type === 'text')">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-select v-model="item.value" :options="[
									{ value: true, label: 'true' },
									{ value: false, label: 'false' },
								]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

					</div>
				</div>
			</q-tab-pane>
			<q-tab-pane name="wqrc_register">
				<div class="row reverse gutter-sm">
					<div class="col-12" v-for="(item, index) in wqrc_register" :key="index">
						<q-field :helper="item.helper" v-if="(item.type === 'boolean' || item.type === 'text')">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" />

							<q-select v-model="item.value" :options="[
									{ value: true, label: 'true' },
									{ value: false, label: 'false' },
								]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

					</div>
				</div>
			</q-tab-pane>

			<q-tab-pane :name="`c${client.id}`" v-for="(client, index) in clients" :key="`p${index}`">
				<div class="row reverse gutter-md">
					<div class="col-12" v-for="(item, index) in client.field" :key="index">
						<q-field :helper="item.helper" v-if="item.type === 'boolean' || item.type === 'text'">
							<q-input type="textarea" v-model="item.value" :float-label="item.label"
								v-if="item.type === 'text'" :disable="item.disabled" />

							<q-select v-model="item.value" :options="[
									{ value: true, label: 'true' },
									{ value: false, label: 'false' },
								]" :float-label="item.label" v-if="item.type === 'boolean'" />
						</q-field>

						<div class="row" v-if="item.type === 'color'">
							<span class="q-caption text-faded">{{ $t('colors') }}</span>
							<div class="col-12" v-for="(color, index) in item.value" :key="`c${index}`">
								<q-field :helper="color.helper">
									<q-color v-model="color.value" :float-label="color.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'set_filter_cards_color'">
							<div class="col-12">
								<q-field :helper="item.helper">
									<q-color v-model="item.value" :float-label="item.label" />
								</q-field>
							</div>
						</div>

						<div class="row" v-if="item.type === 'upload'">
							<span class="q-caption text-faded">{{ item.label }}</span>
							<div class="col-12">
								<uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false"
									:cropper="false" :item="item" :custom_directory="true" :filename="item.label"
									:slug="'clients'" :client_id="client.id"
									:aspect_ratio_string="getAspectString(item)" :no_expiration="true" />
								<span class="q-caption text-faded">{{ item.helper }}</span>

								<p v-if="item.value" class="q-mt-md file-url">
									<q-icon name="fas fa-check" color="positive" />
									<a :href="item.value" target="_blank">
										{{ $truncateLink(item.value) }}</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_overview' })" />
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save"
					@click="saveConfig()" />
			</div>
		</div>

		<q-modal v-model="show_new_configuration_selection" :content-css="{ minWidth: '50vw' }">
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="hideNewConfiguration()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('add_configuration') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row">
						<div class="col-12">
							<q-select :float-label="$t('type')" v-model="new_configuration_type"
								:options="new_configuration_types" />
						</div>
						<div class="col-12">
							<q-input :float-label="$t('slug')" v-model="new_configuration_slug" />
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3">
							<q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="fas fa-ban"
								@click="hideNewConfiguration()" />
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-btn color="secondary" class="full-width" :label="$t('add')" icon="far fa-save"
								@click="addNewConfiguration()" />
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from 'components/Uploader'

export default {
	i18nOptions: { namespaces: ['common', 'admin'] },

	data() {
		return {
			clients: [],
			login: [],
			new_configuration_slug: '',
			new_configuration_target: null,
			new_configuration_type: null,
			new_configuration_types: [
				{
					label: 'text',
					value: 'text',
				},
				{
					label: 'boolean',
					value: 'boolean',
				},
				{
					label: 'upload',
					value: 'upload',
				},
			],
			register: [],
			self_register: [],
			show_new_configuration_selection: false,
			user_profile: [],
			layout: [],
			social_auth: [],
			pqrc_register: [],
			wqrc_register: [],
			custom_input_render: {
				register: ['password_strong_level']
			}
		}
	},

	components: {
		uploader: Uploader,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			user_clients: 'common/user_clients',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},
	},

	methods: {
		hasCustomInputRender(tab, label) {
			if (typeof this.custom_input_render[tab] !== 'undefined') {
				return this.custom_input_render[tab].includes(label);
			}

			return false;
		},

		fetchAll() {
			this.$q.loading.show()

			this.$axios
				.all([this.fetchConfig(), this.fetchDescriptions()])
				.then(
					this.$axios.spread((response, description) => {

						function buildSectionItems(sectionData, sectionDesc = {}) {
							if (!sectionData) return
							const descFields = sectionDesc.fields || {}

							return Object.entries(sectionData).map(([key, value]) => {
								let valueObjList = []

								if (value != null && typeof value === 'object' && !Array.isArray(value)) {
									valueObjList = Object.entries(value).map(([subKey, subVal]) => ({
										label: subKey,
										value: subVal,
										helper: descFields[subKey] || '',
										error: false
									}))
								}

								return {
									label: key,
									value: valueObjList.length ? valueObjList : value,
									error: false,
									helper: valueObjList.length
										? ''
										: (sectionDesc[key] || ''),
									type: valueObjList.length
										? 'field'
										: this.getType(value)
								}
							})
						}

						this.login = Object.entries(response.data.login).flatMap(([key, rawValue]) => {
							switch (key) {
								case 'colors': {
									const valueObjList = Object.entries(rawValue).map(([colorKey, colorVal]) => ({
										label: colorKey,
										value: colorVal,
										helper: description.data.login.colors[colorKey],
										error: false
									}))

									return [{
										label: key,
										value: valueObjList,
										error: false,
										helper: description.data.login[key],
										type: 'color'
									}]
								}

								case 'oauth2': {
									return rawValue.map((obj, index) => {
										const valueObjList = Object.entries(obj).map(([oauthKey, oauthVal]) => ({
											label: oauthKey,
											value: oauthVal,
											helper: '',
											error: false
										}))

										return {
											label: key,
											value: valueObjList,
											error: false,
											helper: '',
											type: 'oauth2',
											index
										}
									})
								}

								case 'background_color':
								case 'font_color': {
									return [{
										label: key,
										value: rawValue,
										error: false,
										helper: description.data.login[key],
										type: key
									}]
								}

								default: {
									return [{
										label: key,
										value: rawValue,
										error: false,
										helper: description.data.login[key],
										type: this.getType(rawValue)
									}]
								}
							}
						})
						this.register = buildSectionItems.call(this, response.data.register, description.data.register)
						this.self_register = buildSectionItems.call(this, response.data.self_register, description.data.self_register)
						this.user_profile = buildSectionItems.call(this, response.data.user_profile, description.data.user_profile)
						this.pqrc_register = buildSectionItems.call(this, response.data.pqrc_register, description.data.pqrc_register)
						this.wqrc_register = buildSectionItems.call(this, response.data.wqrc_register, description.data.wqrc_register)
						this.social_auth = buildSectionItems.call(this, response.data.social_auth, description.data.social_auth)

						this.layout = Object.entries(response.data.layout).map(([key, rawValue]) => {
							let valueObjList = []

							if (rawValue != null && typeof rawValue === 'object' && !Array.isArray(rawValue)) {
								valueObjList = Object.entries(rawValue).map(([subKey, subVal]) => ({
									label: subKey,
									value: subVal,
									helper: description.data.layout.fields[subKey],
									error: false
								}))
							}

							const uploadList = ['footer_social_1_image', 'footer_social_2_image', 'footer_social_3_image', 'footer_social_4_image']
							const colorList = ['footer_background_color', 'footer_text_color']
							const booleanList = ['footer_custom', 'support_use']
							let type = 'text'

							if (uploadList.includes(key)) type = 'upload'
							else if (colorList.includes(key)) type = 'color'
							else if (booleanList.includes(key)) type = 'boolean'

							return {
								label: key,
								value: valueObjList.length ? valueObjList : rawValue,
								error: false,
								helper: valueObjList.length
									? ''
									: description.data.layout[key],
								type
							}
						})

						this.clients = response.data.clients.map(client => {
							const fields = Object.entries(client).reduce((accFields, [key, rawValue]) => {
								let valueObjList = []

								if (rawValue != null && typeof rawValue === 'object' && !Array.isArray(rawValue)) {
									valueObjList = Object.entries(rawValue).map(([colorKey, colorVal]) => ({
										label: colorKey,
										value: colorVal,
										helper: description.data.clients.colors[colorKey] || '',
										error: false
									}))

									accFields.push({
										label: key,
										value: valueObjList,
										disabled: key === 'id',
										helper: '',
										error: false,
										type: 'color'
									})
								} else {
									const commonField = {
										label: key,
										value: rawValue,
										disabled: key === 'id',
										helper: description.data.clients[key] || '',
										error: false,
										type: key === 'set_filter_cards_color'
											? 'set_filter_cards_color'
											: this.getType(rawValue)
									}
									accFields.push(commonField)
								}

								return accFields
							}, [])

							return {
								id: client.id,
								field: fields
							}
						})

					})
				)
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		fetchConfig() {
			return this.$axios.get('/clients/config/', this.getHeader)
		},

		fetchDescriptions() {
			return this.$axios.get('/clients/config/descriptions/', this.getHeader)
		},

		saveConfig() {
			let login = {}
			let colors = {}
			let oauth2 = []

			this.login.forEach((field) => {
				login[field.label] = field.value

				if (field.type === 'color') {
					field.value.forEach((element) => {
						colors[element.label] = element.value
					})
				} else if (field.type === 'oauth2') {
					let new_oauth2 = {}

					field.value.forEach((element) => {
						new_oauth2[element.label] = element.value
					})

					oauth2.push(new_oauth2)
				} else {
					let value = field.value
					if (field.type === 'upload') value = field.value.split('?')[0]
					login[field.label] = value
				}
			})

			login['colors'] = colors
			login['oauth2'] = oauth2

			let register = {}
			let fields = {}

			this.register.forEach((field) => {
				register[field.label] = field.value

				if (field.type != 'field') register[field.label] = field.value
				else {
					field.value.forEach((element) => {
						fields[element.label] = element.value
					})
				}
			})

			register['fields'] = fields

			let self_register = {}
			let fields_self_register = {}

			this.self_register.forEach((field) => {
				self_register[field.label] = field.value

				if (field.type != 'field') self_register[field.label] = field.value
				else {
					field.value.forEach((element) => {
						fields_self_register[element.label] = element.value
					})
				}
			})

			self_register['fields'] = fields_self_register

			let user_profile = {}
			let fields_user_profile = {}

			this.user_profile.forEach((field) => {
				user_profile[field.label] = field.value

				if (field.type != 'field') user_profile[field.label] = field.value
				else {
					field.value.forEach((element) => {
						fields_user_profile[element.label] = element.value
					})
				}
			})

			user_profile['fields'] = fields_user_profile

			let layout = {}
			let fields_layout = {}

			this.layout.forEach((field) => {
				layout[field.label] = field.value

				if (field.type != 'field') layout[field.label] = field.value
				else {
					field.value.forEach((element) => {
						fields_layout[element.label] = element.value
					})
				}
			})

			let social_auth = {}
			let fields_social_auth = {}
			this.social_auth ? this.social_auth.forEach((field) => {

				social_auth[field.label] = field.value

				if (field.type != 'field') social_auth[field.label] = field.value
				else {
					field.value.forEach((element) => {
						fields_social_auth[element.label] = element.value
					})
				}
			}) : social_auth = {}

			let pqrc_register = {}
			let fields_pqrc_register = {}
			this.pqrc_register ? this.pqrc_register.forEach((field) => {

				pqrc_register[field.label] = field.value

				if (field.type != 'field') pqrc_register[field.label] = field.value
				else {
					field.value.forEach((element) => {
						fields_pqrc_register[element.label] = element.value
					})
				}
			}) : pqrc_register = {}


			let wqrc_register = {}
			let fields_wqrc_register = {}
			this.wqrc_register ? this.wqrc_register.forEach((field) => {

				wqrc_register[field.label] = field.value

				if (field.type != 'field') wqrc_register[field.label] = field.value
				else {
					field.value.forEach((element) => {
						fields_wqrc_register[element.label] = element.value
					})
				}
			}) : wqrc_register = {}

			let clients = []

			this.clients.forEach((client_raw) => {
				colors = {}
				let client = {}

				client_raw.field.forEach((field) => {
					if (field.type != 'color') {
						let value = field.value
						if (field.type === 'upload') value = field.value.split('?')[0]
						client[field.label] = value
					} else {
						field.value.forEach((element) => {
							colors[element.label] = element.value
						})
					}
				})

				client['colors'] = colors
				clients.push(client)
			})

			let data = {
				slugs: [
					{
						slug: 'clients',
						clients: clients,
					},
					{
						slug: 'login',
						login: login,
					},
					{
						slug: 'user_profile',
						user_profile: user_profile,
					},
					{
						slug: 'register',
						register: register,
					},
					{
						slug: 'self_register',
						self_register: self_register,
					},
					{
						slug: 'layout',
						layout: layout,
					},
					{
						slug: 'social_auth',
						social_auth: social_auth,
					},
					{
						slug: 'pqrc_register',
						pqrc_register: pqrc_register,
					},
					{
						slug: 'wqrc_register',
						wqrc_register: wqrc_register,
					},
				],
			}

			this.$axios
				.post('/clients/config/', data, this.getHeader)
				.then(() => {
					this.$q.loading.hide()

					this.$q.notify({
						message: this.$t('config_save_successfully'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					this.$q.loading.hide()
				})
		},

		getClientName(id) {
			const obj = this.user_clients.find((obj) => obj.id === id)
			return obj ? obj.name : ''
		},

		disablegetClientName(id) {
			const obj = this.user_clients.find((obj) => obj.id === id)
			return obj ? true : false
		},

		getType(value) {
			const pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/

			if (pattern.test(value)) {
				const imageTypes = ['.jpg', '.png', '.gif', '.svg', '.webp']
				let isUpload = false
				for (let index = 0; index < imageTypes.length; index++) {
					if (value.toLowerCase().endsWith(imageTypes[index])) isUpload = true
				}
				return isUpload ? 'upload' : 'text'
			} else {
				if (typeof value === 'boolean') return 'boolean'
				else return 'text'
			}
		},

		imageUploaded(url, item) {
			item.value = url.split('?')[0]
		},

		newConfiguration(target) {
			this.new_configuration_target = target
			this.show_new_configuration_selection = true
		},

		addNewConfiguration() {
			if (this.new_configuration_type && this.new_configuration_slug) {
				if (this.new_configuration_target === 'login') {
					let key_unique = true

					let obj = this.login.find((obj) => obj.label === this.new_configuration_slug)
					if (obj) key_unique = false

					if (key_unique) {
						this.login.push({
							label: this.new_configuration_slug,
							value: null,
							error: false,
							type: this.new_configuration_type,
						})
					}
				} else if (this.new_configuration_target === 'register') {
					let key_unique = true

					let obj = this.register.find((obj) => obj.label === this.new_configuration_slug)
					if (obj) key_unique = false

					if (key_unique) {
						this.self_register.push({
							label: this.new_configuration_slug,
							value: null,
							error: false,
							type: this.new_configuration_type,
						})
					}
				} else if (this.new_configuration_target === 'self_register') {
					let key_unique = true

					let obj = this.self_register.find(
						(obj) => obj.label === this.new_configuration_slug
					)
					if (obj) key_unique = false

					if (key_unique) {
						this.self_register.push({
							label: this.new_configuration_slug,
							value: null,
							error: false,
							type: this.new_configuration_type,
						})
					}
				} else if (this.new_configuration_target === 'user_profile') {
					let key_unique = true

					let obj = this.user_profile.find(
						(obj) => obj.label === this.new_configuration_slug
					)
					if (obj) key_unique = false

					if (key_unique) {
						this.user_profile.push({
							label: this.new_configuration_slug,
							value: null,
							error: false,
							type: this.new_configuration_type,
						})
					}
				} else {
					let obj = this.clients.find((obj) => obj.id === this.new_configuration_target)
					if (obj) {
						let key_unique = true
						let obj_key = this.login.find(
							(obj_key) => obj_key.label === this.new_configuration_slug
						)

						if (obj_key) key_unique = false

						if (key_unique) {
							obj.field.push({
								label: this.new_configuration_slug,
								value: null,
								error: false,
								type: this.new_configuration_type,
								disabled: false,
							})
						}
					}
				}

				this.hideNewConfiguration()
			}
		},

		hideNewConfiguration() {
			this.new_configuration_target = null
			this.new_configuration_type = null
			this.new_configuration_slug = ''
			this.show_new_configuration_selection = false
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getAspectNumber(item) {
			switch (item.label) {
				case 'mobile_background':
					return 140 / 113
				case 'background':
					return 140 / 113
				case 'email_logo':
					return 600 / 109
				case 'logo_en':
				case 'logo_es':
				case 'logo_fr':
				case 'logo_pt':
				case 'logo':
				case 'logo_mobile_en':
				case 'logo_mobile_es':
				case 'logo_mobile_fr':
				case 'logo_mobile_pt':
				case 'logo_mobile':
				case 'email_logo':
					return 395 / 47
				case 'logo_footer_fr':
				case 'logo_footer_pt':
				case 'logo_footer_es':
				case 'logo_footer_en':
				case 'logo_footer':
					return 395 / 100
				case 'footer_social_1_image':
				case 'footer_social_2_image':
				case 'footer_social_3_image':
				case 'footer_social_4_image':
					return 1 / 1
				case 'full_background':
					return 16 / 9
				case 'default_background_certificate':
					return 877 / 620
				case 'group_library_file_placeholder':
				case 'group_training_placeholder':
				case 'live_class_placeholder':
				case 'news_placeholder':
				case 'podcast_placeholder':
				case 'presential_event_placeholder':
				case 'user_avatar_placeholder':
				case 'webcast_placeholder':
					return 52 / 29
				case 'user_avatar_placeholder':
					return 650 / 650
				case 'home_banner':
					return 1600 / 340
				default:
					return 1280 / 720
			}
		},

		getAspectString(item) {
			switch (item.label) {
				case 'mobile_background':
					return '1080/1927'
				case 'background':
					return '140/113'
				case 'logo':
				case 'logo_en':
				case 'logo_es':
				case 'logo_fr':
				case 'logo_pt':
				case 'logo_mobile':
				case 'logo_mobile_en':
				case 'logo_mobile_es':
				case 'logo_mobile_fr':
				case 'logo_mobile_pt':
				case 'email_logo':
					return '395/47'
				case 'logo_footer_fr':
				case 'logo_footer_pt':
				case 'logo_footer_es':
				case 'logo_footer_en':
				case 'logo_footer':
					return '395/100'
				case 'footer_social_1_image':
				case 'footer_social_2_image':
				case 'footer_social_3_image':
				case 'footer_social_4_image':
					return '1/1'
				case 'full_background':
					return '16/9'
				case 'default_background_certificate':
					return '877/620'
				case 'group_library_file_placeholder':
				case 'group_training_placeholder':
				case 'live_class_placeholder':
				case 'news_placeholder':
				case 'podcast_placeholder':
				case 'presential_event_placeholder':
				case 'user_avatar_placeholder':
				case 'webcast_placeholder':
					return '52/29'
				case 'user_avatar_placeholder':
					return '650/650'
				case 'home_banner':
					return '1600/340'
				default:
					return '1280/720'
			}
		},
	},

	created() {
		this.fetchAll()
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.q-tabs-panes
  max-height 70vh  
  overflow-x auto

.file-url
    a
        text-decoration none
        color black


</style>
